module.exports = __webpack_public_path__ + "videos/17.aed2e48.mp4";